module.exports = __webpack_public_path__ + "img/available-downloads.52e76253.svg";